import { inject, Injectable } from '@angular/core';
import { APIProviderService } from '../api/api.provider.service';
import { WebProviderService } from '../web/web.provider.service';
import { environment } from 'src/environments/environment';
import { assert, assertTrue } from 'src/app/utils/assert.util';
import { ConfiguredItem } from 'src/app/interfaces/configured-item';

@Injectable({
  providedIn: 'root'
})
export class StoneCountsProviderService {

  webProvider = inject(WebProviderService);
  readonly baseURL = environment.apiURL;
  get attributeURL() {
    return '/api/Gemstones';
  }

  async get(configuredItem: ConfiguredItem): Promise<number> {
    const url = new URL(`${this.baseURL}${this.attributeURL}/Count`);
    assert(configuredItem.primaryMaterial, 'primaryMaterial was null');
    assert(configuredItem.secondaryMaterial, 'secondaryMaterial was null');
    assert(configuredItem.size, 'Finger size was null');
    assert(configuredItem.gemstoneSize, 'Stone size was null');
    assert(configuredItem.gemstoneArrangement, 'Arrangement was null');
    assert(configuredItem.gemstoneSetting, 'Setting was null');
    url.searchParams.set('stoneSizeID', configuredItem.gemstoneSize.id.toString());
    url.searchParams.set('stoneArrangementID', configuredItem.gemstoneArrangement.id.toString());
    url.searchParams.set('stoneSettingID', configuredItem.gemstoneSetting.id.toString());
    url.searchParams.set('insideMaterialID', configuredItem.primaryMaterial.id.toString());
    url.searchParams.set('outsideMaterialID', configuredItem.secondaryMaterial.id.toString());
    url.searchParams.set('fingerSizeID', configuredItem.size.id.toString());
    const count = await this.webProvider.get<number>(url.href);
    assert(count, 'Failed to fetch count');
    return count;
  }

  async getMaxBySetting(configuredItem: ConfiguredItem): Promise<number> {
    const url = new URL(`${this.baseURL}${this.attributeURL}/MaxCountBySetting`);
    assert(configuredItem.primaryMaterial, 'primaryMaterial was null');
    assert(configuredItem.secondaryMaterial, 'secondaryMaterial was null');
    assert(configuredItem.size, 'Finger size was null');
    assert(configuredItem.gemstoneSize, 'Stone size was null');
    assert(configuredItem.gemstoneSetting, 'Setting was null');
    url.searchParams.set('stoneSettingID', configuredItem.gemstoneSetting.id.toString());
    url.searchParams.set('stoneSizeID', configuredItem.gemstoneSize.id.toString());
    url.searchParams.set('insideMaterialID', configuredItem.primaryMaterial.id.toString());
    url.searchParams.set('outsideMaterialID', configuredItem.secondaryMaterial.id.toString());
    url.searchParams.set('fingerSizeID', configuredItem.size.id.toString());
    const count = await this.webProvider.get<number>(url.href);
    assert(count, 'Failed to fetch count');
    return count;
  }

    async getMax(configuredItem: ConfiguredItem): Promise<number> {
    const url = new URL(`${this.baseURL}${this.attributeURL}/MaxCount`);
    assert(configuredItem.primaryMaterial, 'primaryMaterial was null');
    assert(configuredItem.secondaryMaterial, 'secondaryMaterial was null');
    assert(configuredItem.size, 'Finger size was null');
    assert(configuredItem.gemstoneSize, 'Stone size was null');
    url.searchParams.set('stoneSizeID', configuredItem.gemstoneSize.id.toString());
    url.searchParams.set('insideMaterialID', configuredItem.primaryMaterial.id.toString());
    url.searchParams.set('outsideMaterialID', configuredItem.secondaryMaterial.id.toString());
    url.searchParams.set('fingerSizeID', configuredItem.size.id.toString());
    const count = await this.webProvider.get<number>(url.href);
    assert(count, 'Failed to fetch count');
    return count;
  }
}
